import gql from "graphql-tag";

export const teachers = gql`
  query teachers($filter: OrgTeacherFilter) {
    teachers(filter: $filter) {
      orgId
      teacherId
      fundraiser
      teacher {
        id
        name
        title
        email
        poolInfo {
          lastModifiedDate
          enabled
          status
        }
      }
    }
  }
`;

export const setTeacher = gql`
  mutation setTeacher($input: SetOrgTeacher!) {
    setTeacher(input: $input)
  }
`;

export const teacherGql = { teachers, setTeacher };
